import React, { type FC } from 'react';
import { FormattedMessage } from 'react-intl-next';

import { LinkMenuItem } from '@atlaskit/side-nav-items/link-menu-item';

import { GoalIconComponent } from '../GlobalNavigationIcons.tsx';
import { i18n } from '../globalNavigationTranslations.ts';

import type { GlobalItemProps } from './globalItemProps.ts';
import { useGlobalItemVisibility } from './useGlobalItemVisibility.ts';

export const GoalsItem: FC<GlobalItemProps> = ({ isHidden, peekingId, setPeekingId }) => {
	const isSelected = false;

	const shouldHide = useGlobalItemVisibility(
		'goals',
		isSelected,
		isHidden,
		peekingId,
		setPeekingId,
	);

	if (shouldHide) {
		return null;
	}

	return (
		<LinkMenuItem href="#" elemBefore={GoalIconComponent}>
			<FormattedMessage {...i18n.goals} />
		</LinkMenuItem>
	);
};
